const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';
export function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}
export function createAction(type, payload = {}) {
  return {
    type,
    payload
  };
}
export function createRequestActions(resource) {
  return {
    request: props => createAction(resource.REQUEST, {
      data: props
    }),
    success: (response, props) => createAction(resource.SUCCESS, {
      data: response,
      props
    }),
    failure: (error, props) => createAction(resource.FAILURE, {
      error,
      props
    })
  };
}
export function mapPayloadTo(...keys) {
  return (...actionCreatorArgs) => {
    return keys.reduce((acc, key, idx) => Object.assign({}, acc, {
      [key]: actionCreatorArgs[idx]
    }), {});
  };
}